<template>
  <pt-scan-payment class="pt-scan-payment__page"></pt-scan-payment>
</template>

<script>
import PtScanPayment from 'cps/new-to-old-audit/pt-scan-payment/withData'
export default {
  name: 'pt-scan-payment__view',
  components: {
    'pt-scan-payment': PtScanPayment
  }
}
</script>
